import React, { useRef } from 'react';
import { uid } from '../_utils';
var DragAndDrop = function (props) {
    var _a = props.message, message = _a === void 0 ? 'Click or drag files to this area' : _a, _b = props.multiple, multiple = _b === void 0 ? true : _b, accept = props.accept, _c = props.iconClass, iconClass = _c === void 0 ? 'fal fa-inbox-in' : _c, className = props.className, onDrop = props.onDrop;
    var fileInput = useRef(null);
    var processFiles = function (files) {
        return Array.from(files).map(function (file) { return ({
            id: uid('file'),
            file: file
        }); });
    };
    var handleFileInput = function (e) {
        var _a;
        e.preventDefault();
        var files = processFiles((_a = e === null || e === void 0 ? void 0 : e.currentTarget) === null || _a === void 0 ? void 0 : _a.files);
        if (files === null || files === void 0 ? void 0 : files.length)
            onDrop === null || onDrop === void 0 ? void 0 : onDrop(files, e);
    };
    var handleDrop = function (e) {
        e.preventDefault();
        var files = processFiles(e.dataTransfer.files);
        if (files === null || files === void 0 ? void 0 : files.length)
            onDrop === null || onDrop === void 0 ? void 0 : onDrop(files, e);
    };
    var classes = ['bg-sky-blue-lightest', 'text-center', 'p-5', 'w-100'];
    if (className)
        classes.push(className);
    return (React.createElement("div", { onDrop: function (e) { return handleDrop(e); }, onDragOver: function (e) { return e.preventDefault(); }, onDragEnter: function (e) { return e.preventDefault(); }, onClick: function () { var _a; return (_a = fileInput === null || fileInput === void 0 ? void 0 : fileInput.current) === null || _a === void 0 ? void 0 : _a.click(); }, className: classes.join(' '), style: { cursor: 'pointer' } },
        React.createElement("div", null,
            !!iconClass && (React.createElement("span", null,
                React.createElement("i", { className: iconClass }),
                "\u00A0")),
            message),
        React.createElement("input", { multiple: multiple, accept: accept, type: "file", className: "d-none", ref: fileInput, onChange: handleFileInput })));
};
export default React.memo(DragAndDrop);
